// extracted by mini-css-extract-plugin
module.exports = {"waveBoi":"WaveBoi-module--waveBoi--e86db3"};